export const AFFILIATE_COOKIES = {
  SERVICE_REFERAL: 90, // Application is waiting for review
};